export class ApiError<T = any> extends Error {
    public errorMessages: string[];
    public response: T;

    constructor(message: string, errorMessages: string[], response: T) {
        super(message);
        this.name = "ApiError";
        this.errorMessages = errorMessages;
        this.response = response;

        // (needed for "instanceof" to work correctly).
        Object.setPrototypeOf(this, ApiError.prototype);
    }
}

